module.exports = __webpack_public_path__ + "static/media/6.68a2d151.jpg";